export const TYPE_1 = "Income";
export const TYPE_2 = "Expense";
export const TYPE_3 = "All";

export const BUS_FAIR_1 = "Bus fair 1";
export const BUS_FAIR_2 = "Bus fair 2";
export const BUS_FAIR_3 = "Bus fair 3";
export const Passport_CREATE = "Passport create";
export const ENDORSEMENT = "Endorsement";
export const IMMIGRATION = "Immigration";
export const TRAINING = "Training";
export const VISA = "Visa";
export const INSURANCE_AGREEMENT = "Insurance Agreement";
export const EMBACY = "Embacy";
export const POLICE_REPORT_CHOP = "Police Report Chop";
export const RMB = "Rmb";
export const BUREAU = "Bureau";
export const AIR_TICKET = "Air ticket";
export const MEDICAL = "Medical";
export const MEDICAL_CHOP = "Medical Chop";
export const EMBASSY = "Embassy";
export const CESS_PAYMENT = "Cees Payment";
export const PCR = "PCR";
export const OTHERS = "Others";
export const FOREIGN_AGENT_LOST = "Foreign Agent Lost";
export const FIN_TYPES = [
  MEDICAL,
  MEDICAL_CHOP,
  EMBASSY,
  CESS_PAYMENT,
  PCR,
  OTHERS,
  FOREIGN_AGENT_LOST,
  BUS_FAIR_1,
  BUS_FAIR_2,
  BUS_FAIR_3,
  Passport_CREATE,
  ENDORSEMENT,
  IMMIGRATION,
  TRAINING,
  VISA,
  INSURANCE_AGREEMENT,
  EMBACY,
  POLICE_REPORT_CHOP,
  RMB,
  BUREAU,
  AIR_TICKET,
];
